import React, { useEffect, useRef, useState } from "react";
import { ExclamationCircleIcon, Flex, Text } from "@paguelofacil/pf-components";

import { REGEX_ONLY_NUMBER } from "../../services/utils/Constants";

import "../../assets/scss/inputs.scss";

export const InputAmountExpand = ({ onChangeValue, maxAmount }) => {
    const spanRef = useRef(null);
    const inputRef = useRef(null);

    const [value, setValue] = useState("");
    const [error, setError] = useState(null);

    const onChange = inputValue => {
        if (maxAmount === 0) {
            setError(`Balance insuficiente`);
        }
        let value = inputValue;
        try {
            const inputValue = value && REGEX_ONLY_NUMBER.test(value) ? value : value?.substring(0, value?.length - 1);
            onChangeValue(inputValue);

            if (REGEX_ONLY_NUMBER.test(inputValue)) {
                if (maxAmount && inputValue > maxAmount) {
                    setError(`El monto debe ser menor a ${maxAmount}`);
                    setValue(inputValue);
                    onChangeValue(null);
                } else {
                    setValue(inputValue);
                    if (!isNaN(inputValue) && inputValue >= 0) {
                        setError(null);
                        const targetValue = parseFloat(inputValue);
                        if (!isNaN(targetValue)) {
                            onChangeValue(targetValue);
                        }
                    } else {
                        setError("Debe ingresar un número mayor a 0");
                    }
                }
            }
        } catch (e) {
            return;
        }
    };

    const onBlur = value => {
        const targetValue = value;
        if (!targetValue) {
            setValue(0.0);
            onChangeValue(0.0);
            return;
        }

        if (!(targetValue && parseFloat(targetValue).toFixed(2) === targetValue.toString())) {
            const newAmount = parseFloat(targetValue).toFixed(2);
            setValue(newAmount);
        }
    };

    useEffect(() => {
        if (spanRef.current && inputRef.current) {
            if (spanRef.current.offsetWidth === 0) inputRef.current.style.width = "5rem";
            else inputRef.current.style.width = `${spanRef.current.offsetWidth + 20}px`;
        }
    }, [value]);

    return (
        <div className="input-wrapper">
            <Flex gap="0" justify="center">
                <Text variant="body4" style={{ textAlign: "center" }}>
                    $
                </Text>
                <input
                    type="text"
                    name="amount"
                    value={value}
                    placeholder="0.00"
                    onChange={e => onChange(e.target.value)}
                    onBlur={e => onBlur(e.target.value)}
                    style={{ width: "3rem" }}
                    ref={inputRef}
                />
                <span ref={spanRef} className="hidden-span">
                    {value}
                </span>
            </Flex>
            {error && (
                <Flex gap="0.25rem">
                    <ExclamationCircleIcon color="#E11900" isFullfill />
                    <span className="message-error">{error}</span>
                </Flex>
            )}
        </div>
    );
};
